import PropTypes from 'prop-types';
import R from 'ramda';
import moment from 'moment';
import objectRecord from '../reducers/object_record';
import { createSelector } from 'reselect';
import deprecated from '../deprecated';

import { param } from './utils';

const selectBookmarkRoot = root => root.bookmarks;

export const selectBookmarksForContent = createSelector(
    selectBookmarkRoot,
    (_, content) => content.id,
    (state, id) => R.propOr([], id, state)
);

export const hasBookmarksForContent = createSelector(
    selectBookmarkRoot,
    (_, content) => content.id,
    (root, id) => root[id] != null
);

export const selectBookmark = createSelector(
    selectBookmarkRoot,
    (root, content) => selectBookmarksForContent(root, content),
    param(2),
    (state, bookmarks, page) => {
        return R.find(R.propEq('page', page), bookmarks);
    }
);
selectBookmark.PropType = PropTypes.shape({
    id: PropTypes.number,
    content_id: PropTypes.number,
    page: PropTypes.number,
    created: PropTypes.string,
});

export const getBookmark = deprecated(
    selectBookmark,
    `Use selectBookmark instead`
);

export function isBookmarked(root, content, page) {
    return selectBookmark(root, content, page) != null;
}

const groupShape = objectRecord({
    label: undefined,
    date: undefined,
    bookmarks: [],
});

const buildGroupList = R.compose(
    R.reverse(),
    R.sortBy(R.prop('date')),
    R.map(groupShape)
);

export const selectBookmarksByDate = createSelector(
    selectBookmarkRoot,
    (root, content) => selectBookmarksForContent(root, content),
    param(2),
    (state, bookmarks, datePoints) => {
        const dateGroups = buildGroupList(datePoints);

        const collectBookmarks = (dateGroups, bookmark) => {
            const created = moment(bookmark.created);

            let found = false;
            return dateGroups.map(group => {
                if (found == false && created > group.date) {
                    found = true;
                    return R.over(
                        R.lensProp('bookmarks'),
                        R.append(bookmark),
                        group
                    );
                }
                return group;
            });
        };

        const tmp = R.compose(
            R.reduce(collectBookmarks, dateGroups),
            R.sort(R.prop('page'))
        );

        return tmp(bookmarks);
    }
);
selectBookmarksByDate.PropType = PropTypes.arrayOf(
    PropTypes.shape({
        label: PropTypes.string,
        date: PropTypes.instanceOf(Date),
        bookmarks: PropTypes.arrayOf(selectBookmark.PropType),
    })
);

export const getByDates = deprecated(
    selectBookmarksByDate,
    `use selectBookmarksByDate instead`
);



// WEBPACK FOOTER //
// ./src/selectors/bookmarks.js